<div class="title">
  <h1>{{ data.type | titlecase }} logs</h1>
  @if (data.logs.length) {
    <span>{{ data.logs.length }} Displayed Logs</span>
  }
</div>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  @for (log of data.logs; track $index) {
    <p>{{ log }}</p>
  }
  @if (!data.logs.length) {
    <p>No entries</p>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="download()" [disabled]="!data.logs.length">Download</button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
